/**
 * HASTA DÓNDE ATRÁS SE PUEDE CREAR UN DÍA DE DIETA (MAC-23, decisión de Francisco, 14-10).
 *
 * «Déjale un margen de un año»: no se crea un día NUEVO con fecha de más de un año antes de
 * hoy. Los que ya existen se siguen viendo y editando (esto solo se mira cuando el día está
 * vacío), y las fechas futuras no se tocan.
 *
 * La regla de verdad la aplica el servidor (`backend/core/dia_nuevo.py`), que no conoce el
 * reloj del cliente y por eso se deja un día de margen. Aquí el hoy es el del cliente
 * (`hoyLocal`), así que la pantalla nunca ofrece crear un día que el servidor vaya a
 * rechazar. La frase es la misma en los dos sitios.
 */
import { hoyLocal, esUnDia } from './horaEspana';

export const FRASE_DIA_DEMASIADO_ANTIGUO = 'Este día es de hace más de un año y ya no se puede crear. '
    + 'Los días que tienes guardados los puedes seguir viendo y editando.';

/** El mismo día un año antes, 'AAAA-MM-DD'. Del 29 de febrero sale el 28. */
const unAnioAntes = (dia) => {
    const [a, m, d] = dia.split('-').map(Number);
    const ultimo = new Date(a - 1, m, 0).getDate();
    const dd = String(Math.min(d, ultimo)).padStart(2, '0');
    return `${a - 1}-${String(m).padStart(2, '0')}-${dd}`;
};

/**
 * @param {string} fecha 'AAAA-MM-DD'
 * @param {string} [hoy] el hoy del cliente
 * @returns {string|null} la frase si un día nuevo con esa fecha no se puede crear; null si sí
 */
export function porQueNoSeCreaElDia(fecha, hoy = hoyLocal()) {
    if (!esUnDia(fecha) || !esUnDia(hoy)) return null;
    return fecha < unAnioAntes(hoy) ? FRASE_DIA_DEMASIADO_ANTIGUO : null;
}
